import Head from "next/head";

const Meta = ({ title, keyword, desc }) => {
  return (
    <div>
      <Head>
        <title>
          {title ? `${title} | Kavana Technologies` : `Kavana Technologies`}
        </title>
        <link rel="icon" href="/favicon.png" />
        <meta name="description" content={desc} />
        <meta name="keyword" content={keyword} />
      </Head>
    </div>
  );
};

Meta.defaultProps = {
  title: "Kavana Technologies",
  keyword:
    "Ethiopia, technology, AI, makretplace, digital items, market, finance, e-commerce, software",
  desc: "Kavana Technologies is a privately held technology service provider company headquartered in Addis Ababa, Ethiopia. We love technolgy, we appreaciate the ease it brings to peoples life and we are committed to contribute to global technological advancements.",
};

export default Meta;
